module.exports = __webpack_public_path__ + "img/aj-design.17675478.jpg";